export function parseBoolean(value, fallback = false) {
    if (value === undefined) {
        return fallback
    }

    return value === 'true' || value === '1'
}

export function parseNumber(value, fallback) {
    const parsedValue = Number(value)

    return Number.isFinite(parsedValue) ? parsedValue : fallback
}

export default function readConfig(element) {
    const dataset = element?.dataset || {}

    return {
        widgetId: dataset.widgetId || element?.id || '',
        sitekey: dataset.sitekey || '',
        lang: dataset.lang || '',
        callback: dataset.callback || '',
        apiVersion: dataset.apiVersion || '1',
        formFieldName: dataset.formFieldName || 'frc-captcha-solution',
        startMode: dataset.startMode || 'focus',
        apiEndpoint: dataset.apiEndpoint || '',
        puzzleEndpoint: dataset.puzzleEndpoint || '',
        behavior: dataset.behavior || 'form',
        submitGate: parseBoolean(dataset.submitGate, true),
        loginRetryReset: parseBoolean(dataset.loginRetryReset, false),
        offcanvasStart: parseBoolean(dataset.offcanvasStart, false),
        showDuration: parseNumber(dataset.showDuration, 1000),
        hideDuration: parseNumber(dataset.hideDuration, 3000),
        maxInitAttempts: parseNumber(dataset.maxInitAttempts, 100),
        initRetryDelay: parseNumber(dataset.initRetryDelay, 50)
    }
}
